import React from 'react'
import PropTypes from 'prop-types'

const formatQueueLabel = (queueType) => {
  if (!queueType) return 'Ranked'
  if (queueType === 'RANKED_TFT_TURBO') return 'Hyper Roll'
  if (queueType === 'RANKED_TFT_DOUBLE_UP') return 'Double Up'
  return queueType.replace('RANKED_TFT', 'Ranked').replace(/_/g, ' ').trim()
}

export const pickPrimaryLeagueEntry = (entries, queueType) => {
  if (!Array.isArray(entries) || entries.length === 0) return null
  const queueTarget = queueType === 'normal' ? 'RANKED_TFT' : undefined
  const rankedEntry = entries.find((entry) => entry.queueType === (queueTarget || 'RANKED_TFT'))
  return rankedEntry || entries[0]
}

const TftRankSnapshot = ({ leagueEntry, className = '' }) => {
  if (!leagueEntry) return null

  const isTurbo = leagueEntry.queueType === 'RANKED_TFT_TURBO'
  const rankLabel = isTurbo
    ? `${leagueEntry.ratedTier || 'Unrated'} ${leagueEntry.ratedRating ?? 0}`.trim()
    : (leagueEntry.tier ? `${leagueEntry.tier} ${leagueEntry.rank}` : 'Unranked')
  const winRate = leagueEntry.wins !== undefined && leagueEntry.losses !== undefined
    ? Math.round((leagueEntry.wins / Math.max(1, leagueEntry.wins + leagueEntry.losses)) * 100)
    : null

  return (
    <div className={`tft-league-card ${className}`.trim()}>
      <div className="tft-league-left tft-league-left--compact">
        <div className="tft-league-title">TFT Rank</div>
        <div className="tft-league-queue">{formatQueueLabel(leagueEntry.queueType)}</div>
      </div>
      <div className="tft-league-stats tft-league-stats--compact">
        <span className="tft-league-chip tft-league-chip--rank">{rankLabel}</span>
        {leagueEntry.leaguePoints !== undefined && (
          <span className="tft-league-chip">{leagueEntry.leaguePoints} LP</span>
        )}
        {winRate !== null && (
          <span className="tft-league-chip">{winRate}% WR</span>
        )}
      </div>
    </div>
  )
}

TftRankSnapshot.propTypes = {
  className: PropTypes.string,
  leagueEntry: PropTypes.shape({
    leaguePoints: PropTypes.number,
    losses: PropTypes.number,
    queueType: PropTypes.string,
    rank: PropTypes.string,
    ratedRating: PropTypes.number,
    ratedTier: PropTypes.string,
    tier: PropTypes.string,
    wins: PropTypes.number
  })
}

export default TftRankSnapshot
